import { useState } from 'react';
import {
  submitLocalAutomationUpdateRequest,
  submitLocalCustomAutomationRequest,
  submitLocalSuggestedAutomationRequest,
} from '@/modules/automations/services';
import {
  buildSuggestedAutomationRequest,
  getInitialCustomAutomationRequest,
} from '@/modules/automations/utils';

function completeLater(callback) {
  setTimeout(callback, 2500);
}

export function useAutomationRequests() {
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [pauseDialogOpen, setPauseDialogOpen] = useState(false);
  const [requestDialogOpen, setRequestDialogOpen] = useState(false);
  const [customRequestDialogOpen, setCustomRequestDialogOpen] = useState(false);
  const [selectedAutomation, setSelectedAutomation] = useState(null);
  const [selectedSuggestedAutomation, setSelectedSuggestedAutomation] = useState(null);
  const [updateRequestText, setUpdateRequestText] = useState('');
  const [newRequestNotes, setNewRequestNotes] = useState('');
  const [customRequest, setCustomRequest] = useState(getInitialCustomAutomationRequest());
  const [updateRequestSent, setUpdateRequestSent] = useState(false);
  const [newRequestSent, setNewRequestSent] = useState(false);
  const [customRequestSent, setCustomRequestSent] = useState(false);

  function openEditDialog(automation) {
    setSelectedAutomation(automation);
    setEditDialogOpen(true);
  }

  function openPauseDialog(automation) {
    setSelectedAutomation(automation);
    setPauseDialogOpen(true);
  }

  function openRequestDialog(automation) {
    setSelectedSuggestedAutomation(automation);
    setRequestDialogOpen(true);
  }

  function openCustomRequestDialog() {
    setCustomRequestDialogOpen(true);
  }

  function closeEditDialog() {
    setEditDialogOpen(false);
    setUpdateRequestText('');
    setUpdateRequestSent(false);
  }

  function closePauseDialog() {
    setPauseDialogOpen(false);
  }

  function closeRequestDialog() {
    setRequestDialogOpen(false);
    setNewRequestNotes('');
    setNewRequestSent(false);
  }

  function closeCustomRequestDialog() {
    setCustomRequestDialogOpen(false);
    setCustomRequest(getInitialCustomAutomationRequest());
    setCustomRequestSent(false);
  }

  function submitUpdateRequest() {
    const result = submitLocalAutomationUpdateRequest(selectedAutomation, updateRequestText);
    if (!result.ok) return result;

    setUpdateRequestSent(true);
    completeLater(closeEditDialog);
    return result;
  }

  function submitSuggestedRequest() {
    submitLocalSuggestedAutomationRequest(
      buildSuggestedAutomationRequest(selectedSuggestedAutomation, newRequestNotes)
    );
    setNewRequestSent(true);
    completeLater(closeRequestDialog);
  }

  function submitCustomRequest() {
    const result = submitLocalCustomAutomationRequest(customRequest);
    if (!result.ok) return result;

    setCustomRequestSent(true);
    completeLater(closeCustomRequestDialog);
    return result;
  }

  function updateCustomRequestField(field, value) {
    setCustomRequest((prev) => ({
      ...prev,
      [field]: value,
    }));
  }

  return {
    editDialogOpen,
    pauseDialogOpen,
    requestDialogOpen,
    customRequestDialogOpen,
    selectedAutomation,
    selectedSuggestedAutomation,
    updateRequestText,
    setUpdateRequestText,
    newRequestNotes,
    setNewRequestNotes,
    customRequest,
    updateCustomRequestField,
    updateRequestSent,
    newRequestSent,
    customRequestSent,
    openEditDialog,
    openPauseDialog,
    openRequestDialog,
    openCustomRequestDialog,
    closeEditDialog,
    closePauseDialog,
    closeRequestDialog,
    closeCustomRequestDialog,
    submitUpdateRequest,
    submitSuggestedRequest,
    submitCustomRequest,
  };
}
